import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Link, Redirect } from 'react-router-dom';
import logo from '../../assets/img/sport/icon.png'

import GenericWebGraph from "../../WebGraph/GenericWebController/GenericWebGraph"
import { CommandInterfaces } from "../GenericWebController/CommandInterpreter/cCommandInterpreter"
import { DebugAlert, Class, Interface, Abstract, ObjectTypes, JSTypeOperator } from "../../WebGraph/GenericCoreGraph/ClassFramework/Class"
import TObject from "../../WebGraph/TagComponents/TObject"
import Actions from "../../WebGraph/GenericWebController/ActionGraph/Actions"
import { CommandIDs } from "../../WebGraph/GenericWebController/CommandInterpreter/CommandIDs/CommandIDs"
import { WebGraph } from "../../WebGraph/GenericCoreGraph/WebGraph/WebGraph"
import Loading from "./Utilities/Loading"
import {withStyles} from "@material-ui/core/styles";
import GlobalStyles from "../../ScriptStyles/GlobalStyles";



var TMainLoading = Class(TObject,
    {
        ObjectType: ObjectTypes.Get("TMainLoading")
        ,
        constructor: function (_Props) {
            TMainLoading.BaseObject.constructor.call(this, _Props);
        }
        ,
        Destroy: function () {
            TMainLoading.BaseObject.Destroy.call(this);
        }
        ,
        render() {
          return (
                <Loading/>
            );
        }
    }, {});

export default withStyles(GlobalStyles)(TMainLoading);

